const privateQuestions = [
    {
        title: 'Please confirm your Forename',
        name: 'first-name',
        type: 'text',
        value: '',
        error: 'Please enter your Forename',
        required: true
    },
    {
        title: 'Please confirm your Surname',
        name: 'surname',
        type: 'text',
        value: '',
        error: 'Please enter your Surname',
        required: true
    },
    {
        title: 'Please confirm your date of birth',
        name: 'date-of-birth',
        type: 'datepicker',
        value: '',
        error: 'Please enter your Date of birth',
        required: true,
        disabledDates: {
            from: new Date(),
        },
    },
    {
        title: 'Please provide your email address',
        name: 'email-address',
        type: 'email',
        value: '',
        error: 'Please enter your email address',
        required: true
    },
    {
        title: 'Please provide your phone number',
        name: 'tel-number',
        type: 'phone-number',
        value: '',
        error: 'Please enter your phone number',
        required: true
    },
];

const corporateQuestions = [
    {
        title: 'Please confirm your unique identifying code',
        name: 'unique-identifying-code',
        type: 'text',
        value: '',
        error: 'Please enter your unique identifying code',
        required: true
    },
    {
        title: 'Please confirm your clients forename',
        name: 'first-name',
        type: 'text',
        value: '',
        error: 'Please enter the clients first name',
        required: true
    },
    {
        title: 'Please confirm your clients surname',
        name: 'surname',
        type: 'text',
        value: '',
        error: 'Please enter the clients surname',
        required: true
    },
    {
        title: 'Please confirm your clients date of birth',
        name: 'date-of-birth',
        type: 'datepicker',
        value: '',
        error: 'Please enter the clients date of birth',
        required: true,
        disabledDates: {
            from: new Date(),
        },
    },
    {
        title: 'Please provide your clients email address',
        name: 'email-address',
        type: 'email',
        value: '',
        error: 'Please enter your clients email address',
        required: true
    },
    {
        title: 'Please provide your clients phone number',
        name: 'tel-number',
        type: 'phone-number',
        value: '',
        error: 'Please enter your clients phone number',
        required: true
    },
    {
        title: 'Please confirm your clients reference number',
        name: 'ref-number',
        type: 'text',
        value: '',
        error: 'Please enter your client reference number',
        required: true
    },
    {
        title: 'Please confirm your organisational email address (Please enter the email address for which you wish to receive correspondence for this case)',
        name: 'mro-email-address',
        type: 'email',
        value: '',
        error: 'Please enter your email address',
        required: true
    },
];

export {corporateQuestions, privateQuestions};